import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/** Fires a pageview whenever the route changes. Mounted once inside <BrowserRouter>. */
export default function AnalyticsRouterListener() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname);
    // Google Analytics 4 SPA pageview
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}
